function ratingScaleFilterString (filter) {
    if (!filter.answers) {
        return '';
    }

    const questionId = surveyAggFriendlyQuestionId(filter);
    if (filter.operator === '<=') {
        const filterString = filter.answers.filter((answer) => answer.value <= filter.value).map((answer) => `${questionId} == "${answer.answerId}"`).join(' || ');

        return `(${filterString})`;
    }

    if (filter.operator === '>=') {
        const filterString = filter.answers.filter((answer) => answer.value >= filter.value).map((answer) => `${questionId} == "${answer.answerId}"`).join(' || ');

        return `(${filterString})`;
    }

    return `${questionId} ${filter.operator} "${filter.answerId}"`;
}

function openAnswerFilterString (filter) {
    const sanitizedString = JSON.stringify(filter.value)
        .toLowerCase()
        .slice(1, -1);

    let filterString = '';

    if (filter.operator === 'contains' || filter.operator === '!contains') {
        filterString = `${filter.operator}(toLowerCase(${surveyAggFriendlyQuestionId(filter)}),"${sanitizedString}")`;
    } else {
        filterString = `toLowerCase(${surveyAggFriendlyQuestionId(filter)}) ${filter.operator} "${sanitizedString}"`;
    }

    if (filter.operator === '!contains' || filter.operator === '!=') {
        filterString += ` && !isNil(${surveyAggFriendlyQuestionId(filter)})`;
    }

    return filterString;
}

export function parseSurveyFilterPipeline (filter) {
    let filterString = '';
    switch (filter.surveyQuestionType) {
        case 'RATING_SCALE':
        case 'SINGLE_CHOICE':
            filterString = ratingScaleFilterString(filter);
            break;
        case 'OPEN_ANSWER':
            filterString = openAnswerFilterString(filter);
            break;
    }

    return { filter: filterString };
}

export function surveyAggFriendlyQuestionId (filter) {
    return `surveyQuestionId_${filter.surveyQuestionId?.replaceAll('-', '')}`; // Survey question ids are prefixed with 'SI-R_', aggregation select keys cannot contain hyphens.
}

export function surveyAggFriendlyTime (filter) {
    return `surveyTime_${filter.surveyQuestionId?.replaceAll('-', '')}`; // Survey question ids are prefixed with 'SI-R_', aggregation select keys cannot contain hyphens.
}
